import VillesForm from "@/components/formateur/VillesForm";

export default function VillesEditPage() {
    return (
        <div className="mx-auto max-w-6xl px-6 py-10" data-testid="page-villes-edit">
            <div className="mb-8">
                <div className="text-xs uppercase tracking-[0.25em] text-brand-orange">Mes villes</div>
                <h1 className="mt-3 font-display text-4xl font-normal tracking-tightest">
                    Villes d'intervention
                </h1>
                <p className="mt-2 max-w-2xl text-brand-smoke">
                    Ajoutez les villes où vous pouvez intervenir et définissez votre rayon d'action.
                </p>
            </div>
            <VillesForm mode="edit" />
        </div>
    );
}
